// NOTE: Keep these types in sync with the corresponding definitions in assessment/types.py.
//
// TODO: extend the generate_client_sources management command to automatically generate TS types
// from python sources, then create this file by feeding assessment/types.py into it.

import { CSVHeaderMap } from "utils/reporting";

export type SectionScoreTableRow = {
  student_id: string;
  student_name: string;
  activities_percent_score: string;
  assignments_percent_score: string;
  prep_work_percent_score: string;
  total_section_score: string;
};

export enum SectionScoreReportHeader {
  activities_score = "activities_score",
  assessed_pages_count = "assessed_pages_count",
  assignments_score = "assignments_score",
  course_code = "course_code",
  email = "email",
  external_id = "external_id",
  prep_score = "prep_score",
  section_external_id = "section_external_id",
  section_score_percent = "section_score_percent",
  section_score_rubric_4 = "section_score_rubric_4",
  section_score_rubric_5 = "section_score_rubric_5",
  section_title = "section_title",
  student_name = "student_name",
  term_title = "term_title",
}

/**
 * Translate from the symbolic table headers emitted by the server into the corresponding
 * translation strings for the full SectionScore report rendered on the admin dashboard.
 */
export const SECTION_SCORE_REPORT_FULL_HEADER_MAP: CSVHeaderMap = {
  [SectionScoreReportHeader.activities_score]:
    "student_section_scores_report.columns.in_class_work_score",
  [SectionScoreReportHeader.assessed_pages_count]:
    "student_section_scores_report.columns.assessed_pages",
  [SectionScoreReportHeader.assignments_score]:
    "student_section_scores_report.columns.assignment_score",
  [SectionScoreReportHeader.course_code]: "student_section_scores_report.columns.course",
  [SectionScoreReportHeader.email]: "student_section_scores_report.columns.student_email",
  [SectionScoreReportHeader.external_id]:
    "student_section_scores_report.columns.student_external_id",
  [SectionScoreReportHeader.prep_score]: "student_section_scores_report.columns.prep_work_score",
  [SectionScoreReportHeader.section_external_id]:
    "student_section_scores_report.columns.section_external_id",
  [SectionScoreReportHeader.section_score_percent]:
    "assessment_dashboard.student_section_scores.section_score_percent",
  [SectionScoreReportHeader.section_score_rubric_4]:
    "assessment_dashboard.student_section_scores.section_score_scale_4",
  [SectionScoreReportHeader.section_score_rubric_5]:
    "assessment_dashboard.student_section_scores.section_score_scale_5",
  [SectionScoreReportHeader.section_title]: "student_section_scores_report.columns.section_title",
  [SectionScoreReportHeader.student_name]: "student_section_scores_report.columns.student_name",
  [SectionScoreReportHeader.term_title]: "student_section_scores_report.columns.term",
};

/**
 * Translate from the symbolic table headers emitted by the server into the corresponding
 * translation strings for the reduced SectionScore report rendered on the section dashboard.
 */
export const SECTION_SCORE_REPORT_REDUCED_HEADER_MAP: CSVHeaderMap = {
  [SectionScoreReportHeader.student_name]: "assessment_dashboard.all.student_name_header_title",
  [SectionScoreReportHeader.prep_score]: "assessment_dashboard.grades.prepwork",
  [SectionScoreReportHeader.activities_score]: "assessment_dashboard.grades.activities",
  [SectionScoreReportHeader.assignments_score]: "assessment_dashboard.grades.assignments",
  [SectionScoreReportHeader.section_score_percent]:
    "assessment_dashboard.student_section_scores.section_score_percent",
  [SectionScoreReportHeader.section_score_rubric_4]:
    "assessment_dashboard.student_section_scores.section_score_scale_4",
  [SectionScoreReportHeader.section_score_rubric_5]:
    "assessment_dashboard.student_section_scores.section_score_scale_5",
};
